


































































import { Component, Prop, Vue, Provide, Watch } from "vue-property-decorator";
import dayjs from "dayjs";

@Component({
  components: {},
})
export default class SearchResultItem extends Vue {
  @Prop() private item!: any;
  @Prop() private type!: any;

  @Provide("$_") $_: any;
  @Provide("$cupIntegration") $cupIntegration: any;

  get isTaxcodesDisplay() {
    return (
      (!this.$route.query.displayType ||
        this.$route.query.displayType === "taxcodes") &&
      this.item.resultType === "Taxcode"
    );
  }

  get truncateLength() {
    return this.isTaxcodesDisplay ? 380 : 130;
  }

  get itemLink() {
    if (this.item.resultType === "Decision") {
      return {
        name: "tree",
        query: {
          tree: this.item.resultDetails.treeId,
          decisionId: this.item.resultDetails.decisionId,
          decisionName: this.item.resultDetails.decisionName,
          tab: "interactive",
        },
      };
    } else if (this.item.resultType === "Tree") {
      return {
        name: "tree",
        query: { tree: this.item.resultDetails.treeId, tab: "interactive" },
      };
    }

    return "#";
  }

  get taxCodeClick() {
    return this.item.resultType === "Taxcode" ? "click" : null;
  }

  async taxCodeClickHandler() {
    if (this.widget) {
      this.$cupIntegration.onUseThis(this.item.resultText);
    } else {
      await this.$copyText(this.item.resultText);
      this.$store.commit(
        "recordToast",
        `${this.item.resultText} copied to clipboard`
      );
    }
  }

  get taxcodeDetails() {
    const details = this.$store.getters.taxcode(this.item.resultText);
    if (details.description === details.additionalDescription) {
      details.additionalDescription = "";
    }

    return details;
  }

  private newTaxcodeText(date) {
    return (
      "New tax code! Code will be active from " +
      dayjs(date).format("D MMM, YYYY")
    );
  }

  private isNewTaxcode(effFrom) {
    return dayjs(effFrom).isAfter(dayjs(new Date()));
  }

  get widget() {
    return this.$store.state.widget;
  }
}
